import { z } from "zod";

export const RecruitmentSourceSchema = z.object({
  sourceId: z.uuid(),
  campaignId: z.uuid(),
  companyId: z.uuid(),
  name: z.string(),
  active: z.boolean(),
  spend_model: z.string(),
  color: z.string().nullable(),
  type: z.string().nullable(),
  cpa_bid: z.number().nullable(),
  cpc: z.number().nullable(),
  cpm: z.number().nullable(),
  daily_budget: z.number().nullable(),
  referral_bonus_per_hire: z.number().nullable(),
  apps_override: z.number().nullable(),
  organic_per_day: z.number().nullable(),
  daily_cap_apps: z.number().nullable(),
  diminishing_exponent: z.number().nullable(),
  saturation_rate: z.number().nullable(),
  funnel_app_to_interview: z.number().nullable(),
  funnel_interview_to_offer: z.number().nullable(),
  funnel_offer_to_hire: z.number().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type RecruitmentSource = z.infer<typeof RecruitmentSourceSchema>;

export const SourceListResponseSchema = z.object({
  sources: z.array(RecruitmentSourceSchema),
  count: z.number(),
});

export type SourceListResponse = z.infer<typeof SourceListResponseSchema>;

export const DeleteSourceResponseSchema = z.object({
  deleted: z.boolean(),
  sourceId: z.uuid(),
});

export type DeleteSourceResponse = z.infer<typeof DeleteSourceResponseSchema>;
